import {
  LEGACY_SIDEBAR_STORAGE_KEY,
  SIDEBAR_COOKIE_OPTIONS,
  SIDEBAR_USER_PREF_COOKIE,
  writeSidebarUserPrefClient,
} from '~/utils/dashboard-sidebar-state'

/**
 * 在 Vue 水合前把 legacy localStorage 写入 user-pref cookie，
 * 避免 composable setup 改 cookie 与 SSR HTML 不一致（刷新后 logo / 宽度 / 按钮错位）。
 */
function migrateLegacySidebarPrefToCookie() {
  try {
    const legacy = localStorage.getItem(LEGACY_SIDEBAR_STORAGE_KEY)
    if (legacy === null) return

    const prefCookie = useCookie(SIDEBAR_USER_PREF_COOKIE, {
      default: () => '',
      ...SIDEBAR_COOKIE_OPTIONS,
    })

    if (prefCookie.value !== 'collapsed' && prefCookie.value !== 'expanded') {
      const parsed = JSON.parse(legacy) === true
      const pref = parsed ? 'collapsed' : 'expanded'
      prefCookie.value = pref
      writeSidebarUserPrefClient(pref)
    }

    localStorage.removeItem(LEGACY_SIDEBAR_STORAGE_KEY)
  } catch {
    localStorage.removeItem(LEGACY_SIDEBAR_STORAGE_KEY)
  }
}

export default defineNuxtPlugin({
  name: 'lip-sidebar-pref-migrate',
  enforce: 'pre',
  order: -10,
  setup() {
    migrateLegacySidebarPrefToCookie()
  },
})
